export const markdownText = (brandingName?) => (`
**Introduction**

Telemedicine involves the use of electronic communications to enable animal health care providers at a different location from the animal to gather information about the animal and/or share individual patient medical information for the purpose of improving animal care. Providers may include primary care veterinarians, specialists, and/or subspecialists. The information may be used for diagnosis, therapy, follow-up and/or education, and may include any of the following:

● Patient medical records

● Medical images

● Real time text communication

● Live two-way audio and video

● Output data from medical devices and sound and video files

Electronic systems used will incorporate network and software security protocols to protect the confidentiality of client and patient&#39;s identification and imaging data and will include measures to safeguard the data and to ensure its integrity against intentional or unintentional corruption.

**Expected Benefits:**

● Improved access to medical care by enabling a client and patient to remain at a remote site while the veterinarian obtains information on the animal and consults at a distant/other sites.

● More efficient medical evaluation and management.

● Obtaining expertise of a distant specialist.

**Possible Risks:**

As with any medical procedure, there are potential risks associated with the use of telemedicine. These risks include, but may not be limited to:

● In rare cases, information transmitted may not be sufficient (e.g. poor resolution of images) to allow for appropriate medical decision making by the veterinarian and consultant(s)

● Delays in medical evaluation and treatment could occur due to deficiencies or failures of the equipment and/or shipment of products.

● In very rare instances, security protocols could fail, causing a breach of privacy of personal medical information

● In rare cases, a lack of access to complete medical records may result in adverse drug interactions or allergic reactions or other judgment errors;

**By signing this form, I understand the following:**

1. I understand that the laws that protect privacy and the confidentiality of medical information also apply to telemedicine, and that no information obtained in the use of telemedicine which identifies me will be disclosed to researchers or other entities without my consent.

2. I understand that I have the right to withhold or withdraw my consent to the use of telemedicine in the course of the patient&#39;s care at any time, without affecting the patient&#39;s right to future care or treatment.

3. I understand that I have the right to inspect all information obtained and recorded in the course of a telemedicine interaction and may receive copies of this information.

4. I understand that a variety of alternative methods of medical care may be available to the patient, and that I may choose one or more of these at any time. Hello Ralphie has explained the alternatives to my satisfaction and I recognize alternatives may be discussed in the telemedicine appointment.

5. I understand that telehealth and telemedicine may involve electronic communication of the patient&#39;s medical information to medical practitioners who may be located in other areas, including out of state.

6. I understand that it is my duty to inform my pet&#39;s primary care veterinarian of electronic interactions regarding his/her care with other healthcare providers.

7. I understand that I may expect the anticipated benefits for the patient from the use of telemedicine in their care, but that no results can be guaranteed or assured.

8. I understand that in an emergent consultation, the responsibility of the telemedicine veterinarian is to advise me on next best steps and that the telemedicine veterinarian&#39;s responsibility will conclude upon the termination of the electronic communication.

**Client Consent to The Use of Telemedicine**

I have read and understand the information provided above regarding telemedicine, have discussed it with my veterinarian or such assistants as may be designated, and all of my questions have been answered to my satisfaction. I hereby give my informed consent for the use of telemedicine in the patient&#39;s medical care.

I hereby authorize a Hello Ralphie veterinarian to use telemedicine in the course of the patient&#39;s evaluation and possible diagnosis and treatment. ${brandingName? (`Hello Ralphie is a partner of ${brandingName}.`) : ""}
`);
